import { render } from "./ModalItem.vue?vue&type=template&id=4920ac48&scoped=true&ts=true"
import script from "./ModalItem.vue?vue&type=script&lang=ts"
export * from "./ModalItem.vue?vue&type=script&lang=ts"

import "./ModalItem.vue?vue&type=style&index=0&id=4920ac48&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4920ac48"]])

export default __exports__